import { ApisauceInstance, create } from 'apisauce';
import merge from 'ramda/src/merge';
import { ClientConfig } from '~client/client-config';
import { DEFAULT_CONFIG } from '~client/default-config';

/**
 * This client is made to be composed with multiple controllers.
 */
export class BaseClient {
  protected api: ApisauceInstance;
  protected config: ClientConfig;

  constructor(config: ClientConfig) {
    const combinedConfig = merge(DEFAULT_CONFIG, config);
    this.api = create(combinedConfig);
    this.config = combinedConfig;
  }

  protected setHeader(header: string, value: string): void {
    this.api.setHeader(header, value);
  }

  public setAuthorization(token: string): void {
    this.api.setHeader('Authorization', `Bearer ${token}`);
  }

  public removeAuthorization(): void {
    this.api.deleteHeader('Authorization');
  }

  public setLanguageHeader(locale: string): void {
    this.setHeader('Accept-Language', locale);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/base-client.ts